import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
import DocumentAction from './document-action';
import DocumentDetails from './document-details';
import useDocumentSummary from './use-document-summary';
type DocumentRowProps = {
  entity: Entity;
  document: TransformedDocument;
};
const DocumentRow = t0 => {
  const $ = _c(17);
  const {
    entity,
    document
  } = t0;
  const {
    title
  } = useDocumentSummary(document);
  const t1 = document.kind === "custom" ? "text-snippet-1" : "text-body-2";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("wrap-anywhere text-primary", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== title) {
    t3 = <p className={t2}>{title}</p>;
    $[2] = t2;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== document) {
    t4 = <DocumentDetails document={document} />;
    $[5] = document;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="min-w-0 flex-1">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== document || $[11] !== entity || $[12] !== title) {
    t6 = <span className="flex shrink-0 items-center"><DocumentAction entity={entity} document={document} title={title} /></span>;
    $[10] = document;
    $[11] = entity;
    $[12] = title;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex items-center gap-3 py-1.5">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default DocumentRow;